import type { ILabRouteRepository, LabRouteListQuery } from '@domain/data-contracts/lab-route-repository.interface';
import type { LabRoute } from '@domain/models/lab-route.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class LabRoutesService {
  public constructor(private readonly repo: ILabRouteRepository) {}

  public list(query: LabRouteListQuery): Promise<PagedResult<LabRoute>> {
    return this.repo.list(query);
  }
}
